import SummaryTypeDTO from './SummaryTypeDTO';
import TransactionTypeDTO from './TransactionTypeDTO';
import NameTypeDTO from './NameTypeDTO';
import GroupTypeDTO from './GroupTypeDTO';
import { ArrayUtil } from 'src/utils';
import LocationInfoDTO from './LocationInfoDTO';
import DataLinkInfoDTO from './DataLinkInfoDTO';

interface APILookupDTO {
    accountNumber: string;
    accountName: string;
    locationId: string;
    code: string;
    locationName: string;
    pos: string;
    sms: string;
    inactive: string;
    tenant: string;
    agentInitalizedConnection: string;
    agentInitalizedAccountingLinkConfig: string;
    agentInitalizedTransactions: string;
    agentLastCompletedRefresh: string;
    agentLastCompletedBatchUpdate: string;
    summaryView: SummaryTypeDTO[];
    transactionView: TransactionTypeDTO[];
    //nameList: NameTypeDTO[];
    groupView: GroupTypeDTO[];
}

const APILookupDTO = {
    create: (initValues?: Partial<APILookupDTO>): APILookupDTO => {
        const defaults: APILookupDTO = {
            summaryView: [],
            transactionView: [],
            //nameList: [],
            groupView: [],
            accountNumber: '',
            accountName: '',
            locationId: '',
            code: '',
            locationName: '',
            pos: '',
            sms: '',
            inactive: '',
            tenant: '',
            agentInitalizedConnection: '',
            agentInitalizedAccountingLinkConfig: '',
            agentInitalizedTransactions: '',
            agentLastCompletedRefresh: '',
            agentLastCompletedBatchUpdate: ''
        };
        const fromInitValues: Partial<APILookupDTO> = initValues != null ? {
            summaryView: ArrayUtil.EasyMap(initValues.summaryView, SummaryTypeDTO.create),
            transactionView: ArrayUtil.EasyMap(initValues.transactionView, TransactionTypeDTO.create),
            //nameList: ArrayUtil.EasyMap(initValues.nameList, NameTypeDTO.create),
            groupView: ArrayUtil.EasyMap(initValues.groupView, GroupTypeDTO.create)
        } : {};
        return { ...defaults, ...initValues, ...fromInitValues };
    }
};

export default APILookupDTO;